import { useBrandConfiguration } from '../contexts/brandConfiguration/hooks';
import { isLocalhost } from './isLocalhost';
export const getImageSrc = (filename) => {
    if (isLocalhost() && typeof window !== 'undefined') {
        return `${window.location.origin}/public/images/${filename}`;
    }
    const { portalUrl } = useBrandConfiguration();
    const imagesPath = 'assets/apps/owpp_nutzungsdauerLandingPage/v1/client/public/images/';
    const basePath = `${portalUrl}/${imagesPath}`;
    return `${basePath}${filename}`;
};
